import { useEffect, useState } from "react";
import {
  signInWithEmail,
  signOut,
  subscribeToAuthState,
} from "@/features/auth/api/identity-platform-auth";
import type { AuthUser } from "@/features/auth/model/auth-user";

export function useAuth() {
  const [user, setUser] = useState<AuthUser | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    return subscribeToAuthState((nextUser) => {
      setUser(nextUser);
      setLoading(false);
    });
  }, []);

  return {
    user,
    loading,
    isAuthenticated: user !== null,
    signIn: signInWithEmail,
    signOut,
  };
}
